import React from 'react'

function HospitolAuditLog() {
  return (
    <div>Audit Log (view system logs, filters by user/date/module)</div>
  )
}

export default HospitolAuditLog